import { AlignmentType, BorderStyle, HeadingLevel, ImageRun, Paragraph, ShadingType, Table, TableCell, TableRow, TextRun, TextWrappingSide, TextWrappingType, VerticalAlign, WidthType } from "docx";

export function objectiveNetworkPage1(certInNetworkCustomerName) {
    return new Paragraph({
        width: { size: 100, type: WidthType.PERCENTAGE },
        spacing: { line: 276, before: 450, after: 300 },
        alignment: AlignmentType.JUSTIFIED,
        children: [
            new TextRun({
                text: `ISECURION security testing team performed vulnerability assessment and penetration testing of the internal network belonging to ${certInNetworkCustomerName}. The overall objective of this engagement was to:`,
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
        ],
    })
}

export function bulletObjectiveNetwork1(certInNetworkCustomerName) {
    return new Paragraph({
        indent: { left: 600 },
        bullet: { level: 0 },
        spacing: { line: 300, after: 10 * 72 * 0.05 },
        children: [
            new TextRun({
                text: "Perform Vulnerability Assessment and Penetration Testing on the Internal Network belonging to "+certInNetworkCustomerName,
                size: 22,
                font: "Calibri",
                bullet: { level: 0 },
                color: '000000',
                italics: false
            })
        ]
    })
}

export const bulletObjective2 = new Paragraph({
    indent: { left: 600 },
    bullet: { level: 0 },
    spacing: { line: 400, after: 10 * 72 * 0.05 },
    children: [
        new TextRun({
            text: "Identify vulnerabilities in the Internal Network.",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false
        })
    ]
})

export function bulletObjective3(certInNetworkCustomerName) {
    return new Paragraph({
        indent: { left: 600 },
        bullet: { level: 0 },
        spacing: { line: 276, after: 10 * 72 * 0.05 },
        children: [
            new TextRun({
                text: `Recommend solutions to mitigate the identified vulnerabilities and help in improving security of ${certInNetworkCustomerName}`,
                size: 22,
                font: "Calibri",
                bullet: { level: 0 },
                color: '000000',
                italics: false
            })
        ]
    })
}

export const scopeHeadingNetwork = new Paragraph({
    spacing: { before: 450, after: 300 },
    children: [new TextRun({
        text: "Scope",
        bold: true,
        color: "c00000",
        size: 26,
        font: "Cambria"
    })],
})

export function scopeNetwork1(certInNetworkCustomerName) {
    return new Paragraph({
        width: { size: 100, type: WidthType.PERCENTAGE },
        spacing: { line: 276, before: 450, after: 300 },
        alignment: AlignmentType.JUSTIFIED,
        children: [
            new TextRun({
                text: `ISECURION performed Vulnerability Assessment and Penetration testing on the distinct components integrated in the below listed Asset of ${certInNetworkCustomerName}.`,
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
        ],
    })
}

export const scopeHeadingNetwork1 = new Paragraph({
    spacing: { before: 350, after: 300 },
    children: [new TextRun({
        text: "Scope",
        bold: true,
        color: "000000",
        size: 24,
        font: "Calibri",
        underline: { type: "single" }
    })],
})

export function scopeTableNetwork(certInNetworkApplicationIP) {
    const ipList = certInNetworkApplicationIP.split(/\s+/); // Splitting IPs by spaces or new lines

    return new Table({
        width: { size: 50, type: WidthType.PERCENTAGE },
        alignment: AlignmentType.CENTER,
        spacing: { before: 450 },
        borders: {
            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
        },
        rows: [
            // Header Row
            new TableRow({
                children: [
                    new TableCell({
                        verticalAlign: VerticalAlign.CENTER,
                        width: { size: 10, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                spacing: { before: 200, after: 200 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Sl. No",
                                        font: "Calibri",
                                        size: 22,
                                        color: "ffffff",
                                        bold: true,
                                    }),
                                ],
                            }),
                        ],
                        shading: { type: ShadingType.SOLID, color: "003366" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                    new TableCell({
                        width: { size: 55, type: WidthType.PERCENTAGE },
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Paragraph({
                                spacing: { before: 200, after: 200 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "IP",
                                        font: "Calibri",
                                        size: 22,
                                        color: "ffffff",
                                        bold: true,
                                    }),
                                ],
                            }),
                        ],
                        shading: { type: ShadingType.SOLID, color: "003366" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                ],
            }),

            // Dynamic Rows for Each IP
            ...ipList.map((ip, index) =>
                new TableRow({
                    children: [
                        new TableCell({
                            children: [
                                new Paragraph({
                                    spacing: { before: 190, after: 190 },
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                        new TextRun({
                                            text: `${index + 1}`, // Incremented index
                                            font: "Calibri",
                                            size: 22,
                                            color: "000000",
                                        }),
                                    ],
                                }),
                            ],
                            borders: {
                                top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            },
                        }),
                        new TableCell({
                            children: [
                                new Paragraph({
                                    spacing: { before: 190, after: 190 },
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                        new TextRun({
                                            text: ip,
                                            font: "Calibri",
                                            size: 22,
                                            color: "000000",
                                        }),
                                    ],
                                }),
                            ],
                            borders: {
                                top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            },
                        }),
                    ],
                })
            ),
        ],
    });
}
